import { z } from 'zod'

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(6, 'Password must be at least 6 characters'),
})

export const adminSchema = z.object({
  email: z.string().email(),
  role: z.string(),
})

export const loginResponseSchema = z.object({
  access_token: z.string(),
  admin: adminSchema,
  message: z.string(),
})

export type LoginFormData = z.infer<typeof loginSchema>
export type LoginResponse = z.infer<typeof loginResponseSchema>
export type Admin = z.infer<typeof adminSchema> 

export const frontroomVideoSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().min(1, 'Description is required'),
  category: z.string().min(1, 'Category is required'),
  videoUrl: z.string().url('Please enter a valid video URL'),
  thumbnailUrl: z.string().url('Please enter a valid thumbnail URL'),
  duration: z.string().min(1, 'Duration is required'),
  isPublished: z.boolean(),
  order: z.number().min(0, 'Order must be 0 or greater').optional(),
  likes: z.number().min(0, 'Likes cannot be negative').optional(),
  views: z.number().min(0, 'Views cannot be negative').optional(),
})

export type FrontroomVideoFormData = z.infer<typeof frontroomVideoSchema>

export const contentCreatorArticleSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  category: z.string().min(1, 'Category is required'),
  shortDescription: z.string().min(10, 'Short description should be at least 10 characters'),
  description: z.string().min(20, 'Description should be at least 20 characters'),
  coverImage: z.string().url('Please enter a valid cover image URL'),
  tags: z.array(z.string().min(1)).min(1, 'Please add at least one tag'),
  status: z.string().min(1, 'Status is required'),
})

export type ContentCreatorArticleFormData = z.infer<typeof contentCreatorArticleSchema>

export const contentCreatorPodcastSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  category: z.string().min(1, 'Category is required'),
  description: z.string().min(10, 'Description should be at least 10 characters'),
  thumbnail: z.string().url('Please enter a valid thumbnail URL'),
  videoUrl: z.string().url('Please enter a valid media URL'),
  tags: z.array(z.string().min(1)).min(1, 'Please add at least one tag'),
  duration: z.number().min(1, 'Duration must be at least 1 second'),
})

export type ContentCreatorPodcastFormData = z.infer<typeof contentCreatorPodcastSchema>